import { createFileRoute } from '@tanstack/react-router';

import Backups from 'component/view/SiteDetails/Backups';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/backups')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.backups(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: Backups,
});
